/************** Footer Newsletter *******************/
$("#agree").change(function() {
  if(this.checked) {
    $(this).next('.check_tooltip').css('display','none');
  }
});
$('body').on('click', '#newsletter__submit_btn', function() {
  if($('#agree').is(':checked')) {
    $('#agree').removeClass('not-selected');
    $('#agree').next('.check_tooltip').css('display','none');
    $(this).submit();
  }else {
    $('#agree').addClass('not-selected');
    setTimeout(function(){
      $('#agree').next('.check_tooltip').css('display','block');
    },100);
    return false;
  }
});


/************** Cart Page *******************/
$("#cart_agree").change(function() {
  if(this.checked) {
    $(this).next('.check_tooltip').css('display','none');
  }
});
$('body').on('click', '#cart__submit_btn', function() {
  if($('#cart_agree').is(':checked')) {
    $('#cart_agree').removeClass('not-selected');
    $('#cart_agree').next('.check_tooltip').css('display','none');
    $(this).addClass('btn--loading');
    $(this).submit();
  }else {
    $('#cart_agree').addClass('not-selected');
    setTimeout(function(){
      $('#cart_agree').next('.check_tooltip').css('display','block');
    },100);
    return false;
  }
});


/************** Side Cart Page *******************/
$("#cart_agree").change(function() {
  if(this.checked) {
    $(this).next('.check_tooltip').css('display','none');
  }
});
$('body').on('click', '#sidecart__submit_btn', function() {
  if($('#cart_agree').is(':checked')) {
    $('#cart_agree').removeClass('not-selected');
    $('#cart_agree').next('.check_tooltip').css('display','none');
    $(this).addClass('btn--loading');
    $(this).submit();
  }else {
    $('#cart_agree').addClass('not-selected');
    setTimeout(function(){
      $('#cart_agree').next('.check_tooltip').css('display','block');
    },100);
    return false;
  }
});



/************** Contact Page *******************/
$("#contact_agree").change(function() {
  if(this.checked) {
    $(this).next('.check_tooltip').css('display','none');
  }
});
$('body').on('click', '#contact__submit_btn', function() {
  if($('#contact_agree').is(':checked')) {
    $('#contact_agree').removeClass('not-selected');
    $('#contact_agree').next('.check_tooltip').css('display','none');
    $(this).submit();
  }else {
    $('#contact_agree').addClass('not-selected');
    setTimeout(function(){
      $('#contact_agree').next('.check_tooltip').css('display','block');
    },100);
    return false;
  }
});


/************** Register Page *******************/
$("#register_agree").change(function() {
  if(this.checked) {
    $(this).next('.check_tooltip').css('display','none');
  }
});
$('body').on('click', '#register__submit_btn', function() {
  if($('#register_agree').is(':checked')) {
    $('#register_agree').removeClass('not-selected');
    $('#register_agree').next('.check_tooltip').css('display','none');
    $(this).submit();
  }else {
    $('#register_agree').addClass('not-selected');
    setTimeout(function(){
      $('#register_agree').next('.check_tooltip').css('display','block');
    },100);
    return false;
  }
});